export enum headers {
  correlationId = "x-correlation-uuid",
  userAgent = "user-agent",
  xForwardedFor = "x-forwarded-for",
  xAmzRequestId = "x-amzn-requestid"
}
